import {
  Error404,
  Error505,
  Login,
  PersonalAgreement,
  PrivacyPolicy,
  UserSettingsEmailPage,
  UserSettingsPage,
  UserSettingsProfilePage,
  BankDetailsPage,
} from 'pages'
import { PageInDevelop } from 'pages/ErrorPage/PageInDevelop'
import { RouteObject } from 'react-router-dom'

import { CompanyRoute } from '../CompanyRoute'
import { ProtectedRoute } from '../ProtectedRoute'
import { PublicRoute } from '../PublicRoute'

export const commonRoutes: RouteObject[] = [
  {
    element: <PublicRoute />,
    children: [
      {
        id: 'login',
        path: '/login',
        element: <Login />,
      },
      {
        id: '505',
        path: '/505',
        element: <Error505 />,
      },
      {
        path: '*',
        element: <Error404 />,
      },
      {
        id: 'develop',
        path: '/develop',
        element: <PageInDevelop />,
      },
      {
        id: 'personalagreement',
        path: '/personalagreement',
        element: <PersonalAgreement />,
      },
      {
        id: 'privacypolicy',
        path: '/privacy-policy',
        element: <PrivacyPolicy />,
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        id: 'settings',
        path: '/settings',
        element: <UserSettingsPage />,
      },
      {
        id: 'settings-email',
        path: '/settings/email',
        element: <UserSettingsEmailPage />,
      },
      {
        id: 'settings-edit',
        path: '/settings/edit',
        element: <UserSettingsProfilePage />,
      },
    ],
  },
  {
    element: <CompanyRoute />,
    children: [
      {
        id: 'settings-bank-details',
        path: '/settings/bank-details',
        element: <BankDetailsPage />,
      },
    ],
  },
]
